import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  href: "https://t.me/smstw88",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "floating-telegram-btn",
  title: "聯繫我們"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-dots-fill" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_ctx.$store.state.AuthModule.user.show_contact_info)
      ? (_openBlock(), _createElementBlock("a", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}